import { RequestHelper } from "@lib-shared/lib";
import StringDictionary from "@lib-shared/types/string-dictionary";
import { appSettings } from "core/config";
import { ApiHeaderKey } from "core/constants";
import { sessionManager } from "core/instances";
import dateWrapper from "core/lib/date.wrapper";
import User from "core/models/user";

class BaseService {
    protected baseUrl = "";
    abortController: AbortController | null = null;

    constructor(abortController: AbortController | null = null) {
        this.abortController = abortController;

    }
    protected get token(): string {
        return sessionManager.accessToken;
    }

    protected get countryCode(): string {
        return User.instance?.countryCode ?? sessionManager.countryCode ?? "";
    }

    protected get customerNumber(): number {
        return sessionManager.loggedInUser?.customerNumber;
    }

    protected setBaseUrl(path: string) {
        const utilService = appSettings.urls.utilityService;
        this.baseUrl = `${utilService}/${path}`;
    }

    protected getRequestHeaders() {
        const headers: StringDictionary = {
            "Authorization": `Bearer ${this.token}`,
            "Content-Type": "application/json"
        };

        headers[ApiHeaderKey.country] = this.countryCode;

        return headers;
    }

    protected getDateString = (date: Date | string) => dateWrapper(date).yearMonthDay();

    protected getRequestHelper(path: string | undefined) {
        const helper = new RequestHelper(this.baseUrl, this.abortController?.signal)

        if (this.token != null) {
            const headers = this.getRequestHeaders();
            helper.withHeaders(headers);
        }

        return helper.withPath(path)
    }

    protected createPromiseRequest(path: string | undefined): RequestHelper {
        const helper = this.getRequestHelper(path);

        return helper.usingPromise();
    }

    //Obsolete
    // protected _createStandardRequest(path: string, callback: any, onError: any) {
    //     const helper = this.getRequestHelper(path);

    //     return helper
    //         .usingCallback(callback)
    //         .usingErrorHandling(onError);
    // }
}

export default BaseService;
